/* =====================================================
   QUICK ADD
===================================================== */

document.addEventListener('submit', async (event) => {

  const form = event.target.closest('[data-quick-add]');

  if (!form) return;

  event.preventDefault();

  const button = form.querySelector(
    '[data-quick-add-button]'
  );

  if (!button) return;

  button.classList.add('is-loading');
  button.disabled = true;

  try {

    const formData = new FormData(form);

    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    document.dispatchEvent(
      new CustomEvent('digi:cart:refresh')
    );

    document.dispatchEvent(
      new CustomEvent('cart:drawer:open')
    );

  } catch(error) {

    console.error(error);

  } finally {

    button.classList.remove('is-loading');
    button.disabled = false;

  }

});

/* =====================================================
   AUTO FILTER
===================================================== */

document.addEventListener('change', (event) => {

  const target = event.target;

  if (
    !target.matches('.digi-search-filters__checkbox')
  ) return;

  const form = target.closest(
    '[data-digi-filters-form]'
  );

  if (!form) return;

  const formData = new FormData(form);

  const params = new URLSearchParams(formData);

  window.location.href =
    `${form.action}?${params.toString()}`;

});

/* =====================================================
   MOBILE FILTER DRAWER
===================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const filters = document.querySelector(
    '.digi-search-filters'
  );

  const openButton = document.querySelector(
    '[data-digi-filters-open]'
  );

  const closeButtons = document.querySelectorAll(
    '[data-digi-filters-close]'
  );

  if (filters && openButton) {

    openButton.addEventListener('click', () => {

      filters.classList.add('is-open');

      document.body.style.overflow = 'hidden';

    });

  }

  closeButtons.forEach(button => {

    button.addEventListener('click', () => {

      if (!filters) return;

      filters.classList.remove('is-open');

      document.body.style.overflow = '';

    });

  });

});